/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form--edit-mode[_ngcontent-%COMP%]   .separator[_ngcontent-%COMP%]{margin-top:3rem;margin-bottom:2rem}.pax-title-h2[_ngcontent-%COMP%]{margin:0;font-family:\"GT Flexa\",Arial,Helvetica,sans-serif;font-size:1.8rem;font-weight:600}.corp-fields__box[_ngcontent-%COMP%]{padding-bottom:18px;padding-top:12px;background-color:#ededed}"];
export { styles as styles };
